var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3838 5.71441C12.8591 5.71441 10.0018 8.57174 10.0018 12.0964C10.0018 15.6211 12.8591 18.4785 16.3838 18.4785C19.9085 18.4785 22.7658 15.6211 22.7658 12.0964C22.7658 8.57174 19.9085 5.71441 16.3838 5.71441ZM8.38379 12.0964C8.38379 7.67816 11.9655 4.09644 16.3838 4.09644C20.8021 4.09644 24.3838 7.67816 24.3838 12.0964C24.3838 16.5147 20.8021 20.0964 16.3838 20.0964C11.9655 20.0964 8.38379 16.5147 8.38379 12.0964Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3838 20.9375C14.2654 20.9375 12.1842 21.5565 10.3493 22.7323C8.5145 23.9081 6.99066 25.5993 5.93088 27.636C5.70182 28.0762 5.19473 28.2269 4.79826 27.9726C4.40178 27.7182 4.26607 27.1552 4.49512 26.715C5.70046 24.3985 7.43362 22.475 9.52047 21.1377C11.6073 19.8004 13.9744 19.0964 16.3839 19.0964C18.7933 19.0965 21.1604 19.8005 23.2472 21.1379C25.334 22.4752 27.0672 24.3988 28.2725 26.7153C28.5015 27.1555 28.3658 27.7185 27.9693 27.9728C27.5728 28.2271 27.0657 28.0764 26.8367 27.6362C25.777 25.5995 24.2531 23.9082 22.4183 22.7324C20.5835 21.5566 18.5023 20.9375 16.3838 20.9375Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d0ca3b51a31f01e35b11017f5d6958de.svg";
export { ForwardRef as ReactComponent };